module.exports = __webpack_public_path__ + "img/engrate.77754491.svg";